module.exports = __webpack_public_path__ + "static/media/aib.312ca44f.png";